class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.filterBtns = document.querySelectorAll('[data-filter-button]');

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    if (facetForm) {
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

      // Immediately update remove button visibility on any checkbox/radio change
      facetForm.addEventListener('change', () => {
        FacetFiltersForm.updateRemoveButtonVisibility();
        FacetFiltersForm.updateFilterCounts();
      });
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.onAccordionClick = this.onAccordionClick.bind(this);
    this.addEventListener('click', this.onAccordionClick);
  }

  onAccordionClick(event) {
    const summary = event.target.closest('summary');
    if (!summary) return;

    const currentDetails = summary.closest('details');
    if (!currentDetails) return;

    const allDetails = this.querySelectorAll('details');
    allDetails.forEach((details) => {
      if (details !== currentDetails && details.hasAttribute('open')) {
        details.removeAttribute('open');
      }
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);

    const filterToggleBtn = document.getElementById('FilterToggle');
    if (filterToggleBtn) {
      filterToggleBtn.addEventListener('click', (event) => {
        event.preventDefault();
        document.body.classList.toggle('show-facets');
      });
    }
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));

    const productGrid = document.getElementById('ProductGridContainer').querySelector('.collection');
    if (productGrid) productGrid.classList.add('loading');

    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const newProductGridContainer = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer');

    if (newProductGridContainer) {
      document.getElementById('ProductGridContainer').innerHTML = newProductGridContainer.innerHTML;
      document.dispatchEvent(new CustomEvent('new-products-loaded'));
    }

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
    if (typeof ReloadSmartWishlist !== "undefined" && typeof ReloadSmartWishlist === 'function') {
      ReloadSmartWishlist();
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            const previousElement = document.getElementById(previousElementId);
            if (previousElement) {
              previousElement.after(elementToRender);
              return;
            }
          }
        }

        if (elementToRender.parentElement) {
          const parent = document.getElementById(elementToRender.parentElement.id);
          if (parent) {
            const sibling = parent.querySelector('.js-filter');
            if (sibling) {
              sibling.before(elementToRender);
            } else {
              parent.appendChild(elementToRender);
            }
          }
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    // Always ensure remove button visibility and filter counts are correct after rendering
    FacetFiltersForm.updateRemoveButtonVisibility();
    FacetFiltersForm.updateFilterCounts();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const target = document.querySelector(selector);
      if (target) target.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
    FacetFiltersForm.updateRemoveButtonVisibility();
  }

  static updateRemoveButtonVisibility() {
    // Check ALL facet forms (page may render the snippet multiple times for mobile/desktop)
    let hasActiveFilters = false;

    document.querySelectorAll('facet-filters-form form').forEach((form) => {
      // Check if any filter checkboxes are checked
      const checkedBoxes = form.querySelectorAll('input[type="checkbox"]:checked');
      if (checkedBoxes.length > 0) hasActiveFilters = true;

      // Check if any price range inputs have values
      if (!hasActiveFilters) {
        const priceInputs = form.querySelectorAll('price-range input[type="number"]');
        priceInputs.forEach((input) => {
          if (input.value && input.value !== '') hasActiveFilters = true;
        });
      }
    });

    // Update ALL remove button instances
    document.querySelectorAll('#FacetRemoveDesktop').forEach((removeBtn) => {
      if (hasActiveFilters) {
        removeBtn.classList.remove('hidden');
      } else {
        removeBtn.classList.add('hidden');
      }
    });
  }

  static updateFilterCounts() {
    // Count total active filters across all forms (use the desktop form as source of truth,
    // fall back to mobile form)
    let totalActive = 0;
    const desktopForm = document.getElementById('FacetFiltersForm');
    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    const form = desktopForm || mobileForm;

    if (form) {
      totalActive += form.querySelectorAll('input[type="checkbox"]:checked').length;
      form.querySelectorAll('price-range input[type="number"]').forEach((input) => {
        if (input.value && input.value !== '') totalActive++;
      });
    }

    // Update desktop filter count badges
    document.querySelectorAll('.desktop-filter-count').forEach((el) => {
      if (totalActive > 0) {
        el.textContent = `(${totalActive})`;
        el.classList.remove('hidden');
      } else {
        el.classList.add('hidden');
      }
    });

    // Update mobile filter count badge
    const mobileCount = document.getElementById('MobileFilterCount');
    if (mobileCount) {
      if (totalActive > 0) {
        mobileCount.textContent = `(${totalActive})`;
        mobileCount.classList.remove('hidden');
      } else {
        mobileCount.classList.add('hidden');
      }
    }
  }

  static renderAdditionalElements(html) {
    const elementSelectors = ['.sorting', '.filterButtonCount', '.resetButtonCount'];
    const filterBtns = document.querySelectorAll('[data-filter-button]');

    elementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;

      if (selector === '.filterButtonCount') {
        let filtersCount = parseInt(html.querySelector(selector).innerHTML, 10);
        filterBtns.forEach(filterBtn => {
          filtersCount > 0 ? filterBtn?.classList.add('populated') : filterBtn?.classList.remove('populated');
        });
      }

      const currentElements = document.querySelectorAll(selector);
      currentElements.forEach(el => {
        el.innerHTML = html.querySelector(selector).innerHTML
      });
    });
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    // Immediately clear all filter checkboxes and price inputs across all forms
    document.querySelectorAll('facet-filters-form form').forEach((form) => {
      form.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
        cb.checked = false;
      });
      form.querySelectorAll('price-range input[type="number"]').forEach((input) => {
        input.value = '';
      });
    });

    // Immediately update the remove button visibility and filter counts
    FacetFiltersForm.updateRemoveButtonVisibility();
    FacetFiltersForm.updateFilterCounts();

    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-max', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
if (!customElements.get('price-range')) {
  customElements.define('price-range', PriceRange);
}

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}
if (!customElements.get('facet-remove')) {
  customElements.define('facet-remove', FacetRemove);
}
